import {
  singleItemWrapper,
  pagedListWrapper,
  listWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type {
  Notification,
  ReadNotificationsBody,
  SubscriptionProvider
} from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { get: getUnreadCount } = singleItemWrapper<number>(apiClient, {
      path: `/api/v${version}/notifications/unread-count`
    })

    const notifications = pagedListWrapper<'id', Notification>()(apiClient, {
      path: `/api/v${version}/notifications`,
      idKey: 'id',
      paginationType: 'lastId'
    })

    const subscriptions = listWrapper<'id', SubscriptionProvider>(apiClient, {
      path: `/api/v${version}/notifications/subscriptions`,
      idKey: 'id'
    })

    const subscribe = async (id: string) => {
      return await apiClient.post(
        `/api/v${version}/notifications/subscriptions/${id}`
      )
    }

    const unsubscribe = async (id: string) => {
      return await apiClient.delete(
        `/api/v${version}/notifications/subscriptions/${id}`
      )
    }

    return {
      getUnreadCount,
      notifications,
      subscriptions,
      subscribe,
      unsubscribe,

      readNotifications: (body: ReadNotificationsBody) =>
        apiClient.post(`/api/v${version}/notifications/read`, { body }),

      readAllNotifications: () =>
        apiClient.post(`/api/v${version}/notifications/read-all`)
    }
  }
} satisfies Starter
